<template>
	<div>
		<div class="foot-tab" :class="{'!rounded-b-none' : noCorners}">
			<div class="foot-tab-head">
				<div class="foot-tab-row-label">
					<span class="cursor-pointer underline zt-hover min-w-[18px] whitespace-nowrap pl-[10px]"
                @click="sortAscending = sortAscending === 0 ? 1 : 0; isLpSet = !isLpSet">L.p</span>
					<span class="cursor-pointer underline zt-hover truncate"
					      :class="{ '!no-underline' : sortColumn === 'name' }"
					      @click="sortTable('name', $event)">{{getTitleString(phaseString)}}</span>
				</div>
				<div class="flex">
					<div class="foot-tab-row-item"
					     :class="{ '!no-underline' : sortColumn === 'matches' }"
					     @click="sortTable('matches', $event)"><div>M</div></div>
					<div class="foot-tab-row-item foot-tab-row-item-family"
					     :class="{ '!no-underline' : sortColumn === 'halfwin' }"
					     @click="sortTable('halfwin', $event)"><div>W</div></div>
					<div class="foot-tab-row-item foot-tab-row-item-family"
					     :class="{ '!no-underline' : sortColumn === 'halfdraw' }" foot-tab-row-item-family
					     @click="sortTable('halfdraw', $event)"><div>R</div></div>
					<div class="foot-tab-row-item foot-tab-row-item-family mr-3"
					     :class="{ '!no-underline' : sortColumn === 'halfloss' }"
					     @click="sortTable('halfloss', $event)"><div>P</div></div>
					<div class="foot-tab-row-item foot-tab-row-item-family"
					     :class="{ '!no-underline' : sortColumn === 'goals_for' }"
					     @click="sortTable('goals_for', $event)"><div>B+</div></div>
					<div class="foot-tab-row-item foot-tab-row-item-family"
					     :class="{ '!no-underline' : sortColumn === 'goals_against' }"
					     @click="sortTable('goals_against', $event)"><div>B-</div></div>
				</div>
			</div>
			<div class="foot-tab-row" :class="{ '!bg-zt-more/35' : selectedTeamsIds.includes(+team.team_id), '!border-b-0 !rounded-b-zt': index === leagueTable.length - 1 }"
			     v-for="(team, index) in leagueTable" :key="team.team_id">
				<div class="foot-tab-row-label" :class="{ '!bg-[#4d5a6d]' : selectedTeamsIds.includes(+team.team_id) }">
					<p class="flex items-center">
						<span class="inline-block w-[22px] !shrink-0">{{isLpSet ?  leagueTable.length - index : index + 1}}.</span>
            <a v-if="!selectedTeamsIds.includes(+team.team_id)"
               :href="team.clickable ? `/wyniki-pilka-nozna/druzyny/${team.query_name}/` : null"
               class="no-default-style" :class="{ 'zt-hover': team.clickable }">
              <span class="flex items-center mr-2 aspect-square h-5">
                <TeamImg :team="team"/>
              </span>
            </a>
            <span v-else class="flex items-center mr-2 aspect-square h-5">
              <TeamImg :team="team"/>
            </span>
						<a v-if="!selectedTeamsIds.includes(+team.team_id)"
               class="no-default-style text-ellipsis line-clamp-1 break-all" :class="{ 'zt-hover': team.clickable }"
               :href="team.clickable ? `/wyniki-pilka-nozna/druzyny/${team.query_name}/` : null">
              {{ team.short_name?.length > 0 ? team.short_name : team.name }}
            </a>
						<span v-else class="text-ellipsis line-clamp-1 break-all">
              {{ team.short_name?.length > 0 ? team.short_name : team.name }}
            </span>
					</p>
				</div>
        <transition appear name="fade" mode="out-in">
          <div :key="filterKey" class="flex">
            <div class="foot-tab-row-item" :class="{ 'foot-tab-row-item-active' : sortColumn === 'matches' }">
              <div>{{ allMatches(team) }}</div>
            </div>
            <div class="foot-tab-row-item foot-tab-row-item-family" :class="{ 'foot-tab-row-item-active' : sortColumn === 'halfwin' }">
              <div>{{ halfsWins(team) }}</div>
            </div>
            <div class="foot-tab-row-item foot-tab-row-item-family" :class="{ 'foot-tab-row-item-active' : sortColumn === 'halfdraw' }">
              <div>{{ halfsDraws(team) }}</div>
            </div>
            <div class="foot-tab-row-item foot-tab-row-item-family mr-3" :class="{ 'foot-tab-row-item-active' : sortColumn === 'halfloss' }">
              <div>{{ halfsLoses(team) }}</div>
            </div>
            <div class="foot-tab-row-item foot-tab-row-item-family" :class="{ 'foot-tab-row-item-active' : sortColumn === 'goals_for' }">
              <div>{{ scoredGoals(team) }}</div>
            </div>
            <div class="foot-tab-row-item foot-tab-row-item-family" :class="{ 'foot-tab-row-item-active' : sortColumn === 'goals_against' }">
              <div>{{ lostGoals(team) }}</div>
            </div>
          </div>
        </transition>
			</div>
		</div>
	</div>
</template>

<script>
import football_mixin from '../../mixins/football_mixin';
import TeamImg from "../football_stats/blocks/TeamImg.vue";

export default {
	name: 'HalfsTable',
	components: {TeamImg},
	inject: ['WP'],
	mixins: [football_mixin],
	props: {
    noCorners: {
      type: Boolean,
      default: false
    },
    phase: {
      type: String,
      default: ''
    },
		teams: Array,
		filters: Array,
		isLpSet: false,
		details: Object,
		selectedTeamsIds: {
			type: Array,
			default: []
		},
    view: {
      type: String,
      default: 'normal',
      validator: function (value) {
        return ['normal', 'compact'].includes(value);
      }
    }
	},
	data() {
		return {
			previousSortColumn: null,
			sortColumn: 'halfwin',
			sortAscending: 0,
			displayedTable: 'all',
			currentSubTab: this.filters[2] ?? 'all',
			half: 'firsthalf',
			teamsSorted: [],
			events: [],
		}
	},
	mounted() {
		this.teamsSorted = this.teams;
		this.requestEvents();
		this.teamsSorted.sort(this.sortTeams).forEach((team, i) => { team.currentTablePosition = i + 1; });
	},
	computed: {
    rowHeight() {
      return this.view === 'compact' ? '28px' : '38px';
    },
    legendBarHeight() {
      return this.view === 'compact' ? '19px' : '30px';
    },
    filterKey() {
      return this.filters.join('-') + `-${ this.view }`;
    },
    phaseString() {
      return this.phase.replace('_', ' ');
    },
		leagueTable() {
			if (this.teamsSorted && this.teamsSorted.length > 0 && this.events.length > 0) {
				return this.teamsSorted.sort(this.sortTeams);
			}	else {
				return this.teamsSorted;
			}
		},
	},
	watch: {
		filters(newVal) {
			setTimeout(() => {
				this.currentSubTab = newVal[2];
				this.half = newVal[1];
				this.leagueTable.sort(this.sortTeams).forEach((team, i) => { team.currentTablePosition = i + 1; });
			}, 250);
		},
	},
	methods: {
		scoredGoals(team) {
			return this.getTeamMatches(team).reduce((sum, match) => {
				const isLocalTeam = match.localteam_id === team.team_id;
				const localGoals = isLocalTeam ? match.localteam_stats : match.visitorteam_stats;

				if (this.half === 'firsthalf') {
					if (this.currentSubTab === 'all' || (this.currentSubTab === 'home' && isLocalTeam) || (this.currentSubTab === 'away' && !isLocalTeam)) {
						return sum + +localGoals.fh_goals;
					}
				} else if (this.half === 'secondhalf') {
					const localSecondHalfGoals = +localGoals.ft_goals - +localGoals.fh_goals;
					if (this.currentSubTab === 'all' || (this.currentSubTab === 'home' && isLocalTeam) || (this.currentSubTab === 'away' && !isLocalTeam)) {
						return sum + localSecondHalfGoals;
					}
				}
				return sum;
			}, 0);
		},
		lostGoals(team) {
			return this.getTeamMatches(team).reduce((sum, match) => {
				const isLocalTeam = match.localteam_id === team.team_id;
				const opponentGoals = isLocalTeam ? match.visitorteam_stats : match.localteam_stats;

				if (this.half === 'firsthalf') {
					if (this.currentSubTab === 'all' || (this.currentSubTab === 'home' && isLocalTeam) || (this.currentSubTab === 'away' && !isLocalTeam)) {
						return sum + +opponentGoals.fh_goals;
					}
				} else if (this.half === 'secondhalf') {
					const opponentSecondHalfGoals = +opponentGoals.ft_goals - +opponentGoals.fh_goals;
					if (this.currentSubTab === 'all' || (this.currentSubTab === 'home' && isLocalTeam) || (this.currentSubTab === 'away' && !isLocalTeam)) {
						return sum + opponentSecondHalfGoals;
					}
				}
				return sum;
			}, 0);
		},
		points(team) {
			return this.getTeamMatches(team).reduce((sum, match) => {
				const isLocalTeam = match.localteam_id === team.team_id;
				const localGoals = isLocalTeam ? match.localteam_stats : match.visitorteam_stats;
				const visitorGoals = isLocalTeam ? match.visitorteam_stats : match.localteam_stats;

				if (this.half === 'firsthalf') {
					if (this.currentSubTab === 'all' || (this.currentSubTab === 'home' && isLocalTeam) || (this.currentSubTab === 'away' && !isLocalTeam)) {
						if (+localGoals.fh_goals > +visitorGoals.fh_goals) {
							return sum + 3;
						} else if (+localGoals.fh_goals === +visitorGoals.fh_goals) {
							return sum + 1;
						}
					}
				} else if (this.half === 'secondhalf') {
					const localSecondHalfGoals = +localGoals.ft_goals - +localGoals.fh_goals;
					const visitorSecondHalfGoals = +visitorGoals.ft_goals - +visitorGoals.fh_goals;
					if (this.currentSubTab === 'all' || (this.currentSubTab === 'home' && isLocalTeam) || (this.currentSubTab === 'away' && !isLocalTeam)) {
						if (localSecondHalfGoals > visitorSecondHalfGoals) {
							return sum + 3;
						} else if (localSecondHalfGoals === visitorSecondHalfGoals) {
							return sum + 1;
						}
					}
				}
				return sum;
			}, 0);
		},
		halfsWins(team) {
			return this.getTeamMatches(team).reduce((sum, match) => {
				const isLocalTeam = match.localteam_id === team.team_id;
				const localGoals = isLocalTeam ? match.localteam_stats : match.visitorteam_stats;
				const visitorGoals = isLocalTeam ? match.visitorteam_stats : match.localteam_stats;

				if (this.half === 'firsthalf') {
					if (this.currentSubTab === 'all' || (this.currentSubTab === 'home' && isLocalTeam) || (this.currentSubTab === 'away' && !isLocalTeam)) {
						if (+localGoals.fh_goals > +visitorGoals.fh_goals) {
							return sum + 1;
						}
					}
				} else if (this.half === 'secondhalf') {
					const localSecondHalfGoals = +localGoals.ft_goals - +localGoals.fh_goals;
					const visitorSecondHalfGoals = +visitorGoals.ft_goals - +visitorGoals.fh_goals;
					if (this.currentSubTab === 'all' || (this.currentSubTab === 'home' && isLocalTeam) || (this.currentSubTab === 'away' && !isLocalTeam)) {
						if (localSecondHalfGoals > visitorSecondHalfGoals) {
							return sum + 1;
						}
					}
				}
				return sum;
			}, 0);
		},
		halfsLoses(team) {
			return this.getTeamMatches(team).reduce((sum, match) => {
				const isLocalTeam = match.localteam_id === team.team_id;
				const localGoals = isLocalTeam ? match.localteam_stats : match.visitorteam_stats;
				const visitorGoals = isLocalTeam ? match.visitorteam_stats : match.localteam_stats;

				if (this.half === 'firsthalf') {
					if (this.currentSubTab === 'all' || (this.currentSubTab === 'home' && isLocalTeam) || (this.currentSubTab === 'away' && !isLocalTeam)) {
						if (+localGoals.fh_goals < +visitorGoals.fh_goals) {
							return sum + 1;
						}
					}
				} else if (this.half === 'secondhalf') {
					const localSecondHalfGoals = +localGoals.ft_goals - +localGoals.fh_goals;
					const visitorSecondHalfGoals = +visitorGoals.ft_goals - +visitorGoals.fh_goals;
					if (this.currentSubTab === 'all' || (this.currentSubTab === 'home' && isLocalTeam) || (this.currentSubTab === 'away' && !isLocalTeam)) {
						if (localSecondHalfGoals < visitorSecondHalfGoals) {
							return sum + 1;
						}
					}
				}
				return sum;
			}, 0);
		},
		halfsDraws(team) {
			return this.getTeamMatches(team).reduce((sum, match) => {
				const isLocalTeam = match.localteam_id === team.team_id;
				const localGoals = isLocalTeam ? match.localteam_stats : match.visitorteam_stats;
				const visitorGoals = isLocalTeam ? match.visitorteam_stats : match.localteam_stats;

				if (this.half === 'firsthalf') {
					if (this.currentSubTab === 'all' || (this.currentSubTab === 'home' && isLocalTeam) || (this.currentSubTab === 'away' && !isLocalTeam)) {
						if (+localGoals.fh_goals === +visitorGoals.fh_goals) {
							return sum + 1;
						}
					}
				} else if (this.half === 'secondhalf') {
					const localSecondHalfGoals = +localGoals.ft_goals - +localGoals.fh_goals;
					const visitorSecondHalfGoals = +visitorGoals.ft_goals - +visitorGoals.fh_goals;
					if (this.currentSubTab === 'all' || (this.currentSubTab === 'home' && isLocalTeam) || (this.currentSubTab === 'away' && !isLocalTeam)) {
						if (localSecondHalfGoals === visitorSecondHalfGoals) {
							return sum + 1;
						}
					}
				}
				return sum;
			}, 0);
		},
		goalDiff(team) {
			return this.scoredGoals(team) - this.lostGoals(team);
		},
		sortTeams(a,b) {
			let diff = 0;
			if (this.sortColumn === 'name') {
				if (this.sortAscending) {
					diff = a.name.localeCompare(b.name);
				} else {
					diff = b.name.localeCompare(a.name);
				}
				return diff;
			}
			switch (this.sortColumn) {
				case 'bm':
					if (this.sortAscending) {
						diff = +this.allGoals(a).split(':')[0] - +this.allGoals(b).split(':')[0] || +this.allGoals(b).split(':')[1] - +this.allGoals(a).split(':')[1];
					} else {
						diff = +this.allGoals(b).split(':')[0] - +this.allGoals(a).split(':')[0] || +this.allGoals(a).split(':')[1] - +this.allGoals(b).split(':')[1];
					}
					break;
				case 'matches':
					if (this.sortAscending) {
						diff = this.allMatches(a) - this.allMatches(b);
					} else {
						diff = this.allMatches(b) - this.allMatches(a);
					}
					break;
				case 'goals_for':
					if (this.sortAscending) {
						diff = this.scoredGoals(a) - this.scoredGoals(b);
					} else {
						diff = this.scoredGoals(b) - this.scoredGoals(a);
					}
					break;
				case 'goals_against':
					if (this.sortAscending) {
						diff = this.lostGoals(a) - this.lostGoals(b);
					} else {
						diff = this.lostGoals(b) - this.lostGoals(a);
					}
					break;
				case 'goal_diff':
					if (this.sortAscending) {
						diff = this.goalDiff(a) - this.goalDiff(b);
					} else {
						diff = this.goalDiff(b) - this.goalDiff(a);
					}
					break;
				case 'halfwin':
					if (this.sortAscending) {
						diff = this.halfsWins(a) - this.halfsWins(b);
					} else {
						diff = this.halfsWins(b) - this.halfsWins(a);
					}
					break;
				case 'halfdraw':
					if (this.sortAscending) {
						diff = this.halfsDraws(a) - this.halfsDraws(b);
					} else {
						diff = this.halfsDraws(b) - this.halfsDraws(a);
					}
					break;
				case 'halfloss':
					if (this.sortAscending) {
						diff = this.halfsLoses(a) - this.halfsLoses(b);
					} else {
						diff = this.halfsLoses(b) - this.halfsLoses(a);
					}
					break;
				case 'points':
				default:
					if (this.sortAscending) {
						diff = this.points(a) - this.points(b);
					} else {
						diff = this.points(b) - this.points(a);
					}
					break;
			}
			return diff;
		},
		requestEvents() {
			if (this.events.length > 0) {
				return;
			}
			let matches = new Set();
			this.leagueTable.forEach((team) => {
				team.matches.forEach((match) => {
					if (this.checkStatus(match.status))
						if(!matches.has(parseInt(match.match_id))) {
							matches.add(parseInt(match.match_id));
						}
				});
			});
			axios
				.post(this.WP.ajaxUrl, {
					endpoint: 'api_get_match_events',
					matches: Array.from(matches),
					type: 'Goal'
				})
				.then(response => {
					if (response.data.success) {
						this.events = response.data.data;
					}
				});
		}
	}
}
</script>
<style scoped>
.foot-tab-row-item {
  height: v-bind(rowHeight);
}

.foot-tab-row {
  height: v-bind(rowHeight);
}

.foot-tab-row-marked-red::before, .foot-tab-row-marked-red-variant::before,
.foot-tab-row-marked-blue::before, .foot-tab-row-marked-blue-variant::before,
.foot-tab-row-marked-purple::before, .foot-tab-row-marked-purple-variant::before,
.foot-tab-row-marked-green::before, .foot-tab-row-marked-green-variant::before {
  height: v-bind(legendBarHeight);
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>